import { ObservableArray, View } from "binder"
import { DebtorsAndCreditorsListViewModel, singleBalance } from "./debtorsAndCreditorsList-viewModel"

export class DebtorsAndCreditorsListView extends View<DebtorsAndCreditorsListViewModel>{
    GetViewUniqueId(): string {
        return "V-4433E607-E627-4576-808F-7FF50D0F0D91"
    }
    loadHtml(): string {
        let element = require('./debtorsAndCreditorsList.html').default;
        let style = require('./debtorsAndCreditorsList.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set balances(v: ObservableArray<singleBalance>) { this._balances = v; } public get balances(): ObservableArray<singleBalance> { return this._balances;} private _balances: ObservableArray<singleBalance>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;

    export() {
        this.dataContext.export();
    }

}
